import { useEffect, useState } from 'react'
import EventEmitter, {
  SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO,
} from '../../../helpers/EventEmitter'
import { PopupAction } from '../PopupAction'
import { Content } from './Content'
import './i18n'

export const PopupManageCompanyPortfolio = () => {
  const [isShow, setIsShow] = useState(false)

  const handleClose = () => {
    setIsShow(false)
  }

  useEffect(() => {
    EventEmitter.subscribe(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, setIsShow)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, setIsShow)
    }
  }, [])

  return (
    <PopupAction
      appendStyle={{
        backgroundColor: '#F3F3F3',
        borderRadius: 4,
        width: 750,
        padding: 20,
      }}
      isShow={isShow}
      title={'common.popup.manageCompanyPortfolio.TITLE'}
      handleClose={handleClose}
      btnCancel={{
        label: 'common.CLOSE',
        isI18n: true,
        event: handleClose,
      }}
    >
      <Content />
    </PopupAction>
  )
}
